import React, { Component } from "react";
import M from 'materialize-css';


class CuentaClabe extends Component {

    render() {
        return (
            <div className='row'>
                <div className='col s12 left-align mt-1 ft-10 mb-0px' style={{
                    color: '#797F97'
                }}>
                    Cuenta CLABE
                </div>
                <div className='col s12 center-align mt-0px' style={{
                    backgroundColor: '#F4F4F6',
                    borderRadius: '8px',
                    fontSize: '20px',
                    padding: '16px'
                }}>
                    <span className='boldText' id="cuentaClabe">{ this.props.data.cuentaBancariaDeposito || ""}</span> <i className='material-icons right cursorPointer' style={{
                        color: '#41BBC9'
                    }} 

                    
                        onClick={() => {
                            const texto = document.getElementById("cuentaClabe")?.textContent;
                            if (texto) {
                                navigator.clipboard.writeText(texto)
                                    .then(() => {
                                        M.toast({ html: "Cuenta CLABE copiada al portapapeles. <i class='material-icons right'>check_circle</i>", classes: 'green darken-3 ft-16' });
                                    })
                                    .catch((err) => {
                                        console.error("Error al copiar: ", err);
                                    });
                            }

                        }}
                    >content_copy</i>
                </div>
                <div className='col s12 mt-1 ft-12 ft-12'>
                    1. Ingresa a la app o plataforma en línea de tu banco.
                </div>
                <div className='col s12 mt-1 ft-12'>
                    2. Selecciona la opción <span style={{ color: '#00205C' }} className='boldText'>"Transferir a nuevo destinatario".</span>
                </div>
                <div className='col s12 mt-1 ft-12'>
                    3. Introduce los <span style={{ color: '#00205C' }} className='boldText'>18 dígitos de la CLABE</span> que te asignamos.
                </div>
                <div className='col s12 mt-1 ft-12'>
                    4. Ingresa el monto a transferir
                </div>
                <div className='col s12 mt-1 ft-12'>
                    5. En el beneficiario, escribe el nombre del titular del contrato.
                </div>
                <div className='col s12 mt-1 ft-12'>
                    6. Revisa que todos los datos sean correctos y confirma la operación.
                </div>

                <div className='col s12 mt-1'>
                    <div className='col s2 center-align'>
                        <i className='material-icons mt-1' style={{ fontSize: '40px', color: '#41BBC9' }}>info_outline</i>
                    </div>
                    <div className='col s10 ft-12 align-justify'>
                        Las <span style={{ color: '#00205C' }} className='boldText'>transferencias SPEI están disponibles de lunes a viernes de 6:00 hrs a 18:00 hrs.</span>
                        Transferencias fuera de horario serán rechazadas.
                    </div>
                </div>
            </div>
        )
    }


}

export default CuentaClabe;